module.exports = __webpack_public_path__ + "redbroking.png?409511bc47146d3058460e71fa857941";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/redbroking.png
// module id = 228
// module chunks = 0